<template lang="pug">
#app
  v-container(grid-list-xl, fluid)
    v-layout(row, wrap, v-if="auditoria.id")
      v-flex(lg12)
        v-card.elevation-1.pa-1
          v-flex.md8
            span.title {{ auditoria.auditado.nome }}
            p.body-1.font-weight-light {{ auditoria.auditado.identificador }}
          //- v-flex.md4.xs12
            v-select(label="Status", :items="allStatus", :disabled="!allStatus.length", item-text="nome", item-value="id", color="gray", v-model="filter.status", name="status", :filter="this.$root.customFilter")
    v-layout(row, wrap, v-if="auditoria.id")
      v-flex.xs12
        v-card.elevation-1.pa-3
          v-layout(row, wrap).pa-0
            v-flex.md6.xs6
              span.title {{ auditoria.questionario.nome }}
            v-flex.md3.xs3.text-xs-center
              v-switch.mt-0(:false-value="0", :true-value="1", :color="filter.abertas ? 'success': ''", :label="filter.abertas ? 'Somente questões abertas' : 'Somente questões fechadas'", v-model="filter.abertas")
            v-flex.md3.xs3.text-xs-right
              v-chip(label, small, :color="['#808080', '#EC971F', '#318837', '#C9302C'][auditoria.status]").text-uppercase.white--text.font-weight-bold {{ auditoria.status | statusAuditoria }}

    v-layout(row, wrap, v-if="auditoria.id")
      v-flex.xs12
        v-card.elevation-1
          v-layout(row, wrap)
            v-flex(v-if="listCategorias && listCategorias.length").md12
              v-expansion-panel.elevation-0
                v-expansion-panel-content(v-for='categoria in listCategorias', :key='categoria.idCategoria')
                  template(v-slot:header='')
                    span.title(style="position: relative; left: -4px") {{ categoria.nomeCategoria }}
                  v-card
                    v-card-text
                      v-layout(row, wrap).pa-2
                        v-flex(v-for='questao in categoria.questoes', :key='categoria.idQuestao', @click="openDialogResultado(questao)").md12.conteudo
                          v-layout(row, wrap).mx-0
                            v-flex.md10
                              span.subheading {{ questao.nomeQuestao }}
                              br
                              span(v-if="questao.dataLimite").caption Data de Referência: {{ questao.dataReferencia | moment('DD/MM/YYYY') }} - Data Limite: {{ questao.dataLimite | moment('DD/MM/YYYY') }}
                              span(v-if="!questao.dataLimite").caption Data de Referência: {{ questao.dataReferencia | moment('DD/MM/YYYY') }}
                              br
                              v-chip(v-if="questao.resultado && questao.resultado.anexos && questao.resultado.anexos.length", label, small, color="#E6E6E6").text-uppercase.font-weight-medium.caption.black--text.mx-0 {{ questao.resultado.anexos.length }} Evidências anexadas
                              v-chip(v-if="questao.localizacao", label, small, color="#C9302C").mx-0.text-uppercase.font-weight-medium.caption.white--text Requer localização
                            v-flex.md2.text-xs-right
                              v-chip(v-if="questao.resultado && questao.resultado != 0", label, small, :color="$root && $root.bgStatusResultado[questao.resultado.status] && $root.bgStatusResultado[questao.resultado.status].bgColor").text-uppercase.font-weight-medium.caption.white--text {{ questao.resultado.status | statusResultadoValor }}
                              v-chip(v-if="!questao.resultado", label, small, color="#E6E6E6").text-uppercase.font-weight-medium.caption.black--text Não respondido
                          v-divider
      v-flex(v-if="!listCategorias || !listCategorias.length").md12.text-xs-center
        span.headline Nenhuma informação encontrada!

    v-dialog(v-model="dialogResultado", width="auto", scrollable, max-width="1000px", persistent)
      v-card
        form(@submit.prevent="salvar")
          v-card-title.headline.grey.lighten-2
            v-layout(row, wrap)
              v-flex.md11
                span.headline {{ resultadoAux.nomeQuestao }}
              v-flex.md1.text-xs-right.mt-0
                v-tooltip(top)
                  v-btn(icon, slot="activator", @click.native="$validator.pause(); dialogResultado = false; resultadoAux = {}").pa-0.mx-0.my-0.ma-0
                    v-icon close
                  span Fechar
          v-card-text.white
              v-layout(row, wrap)
                v-flex.md9
                  span.subheading {{ resultadoAux.nomeQuestao }}
                  br
                  span(v-if="resultadoAux.dataLimite").caption Data de Referência: {{ resultadoAux.dataReferencia | moment('DD/MM/YYYY') }} - Data Limite: {{ resultadoAux.dataLimite | moment('DD/MM/YYYY') }}
                  span(v-if="!resultadoAux.dataLimite").caption Data de Referência: {{ resultadoAux.dataReferencia | moment('DD/MM/YYYY') }}
                  br
                  v-chip(v-if="resultadoAux.localizacao", label, small, color="#C9302C").mx-0.text-uppercase.font-weight-medium.caption.white--text Requer localização
                v-flex.md3.pa-1.text-xs-right
                  v-chip(v-if="resultadoAux.resultado && resultadoAux.resultado != 0", label, small, :color="$root && $root.bgStatusResultado[resultadoAux.resultado.status] && $root.bgStatusResultado[resultadoAux.resultado.status].bgColor && $root.bgStatusResultado[resultadoAux.resultado.status].bgColor").text-uppercase.font-weight-medium.caption.white--text {{ resultadoAux.resultado.status | statusResultadoValor }}
                  v-chip(v-if="!resultadoAux.resultado", label, small, color="#E6E6E6").text-uppercase.font-weight-medium.caption.black--text Não respondido
                v-flex.md12
                  v-radio-group(v-model="resultadoAux.opcao_questao_id", row, :disabled="!edicaoHabilitada")
                    v-radio(color="primary",  v-for='opcao in resultadoAux.opcoesQuestao', :key='opcao.id', :label='`${opcao.texto}`', :value='opcao.id', @change="getMinEvidencias(opcao)").mt-2

                v-flex.md12
                  span.subheading.font-weight-bold Dica:
                  v-btn(v-if="resultadoAux.dicaImagemQuestao", flat, color="black", type="button", @click="dialogDicaImagem = true; dicaImagemAux = resultadoAux.dicaImagemQuestao").font-weight-bold.text-none.body-1.pa-2.mx-2.my-0.ma-0.pa-2 Visualizar imagem
                  br
                  span.subheading {{ resultadoAux.dicaQuestao }}

                v-flex(v-if="anexosAlertaVencimento.length").md12.mb-2
                  v-alert(type="warning", :value="true", outline).pa-2
                    span.font-weight-bold {{ anexosAlertaVencimento.length }} documento(s) com vencimento próximo ou vencido:&nbsp;
                    span(v-for="(a, i) in anexosAlertaVencimento", :key="a.id")
                      | {{ a.nome_original || 'Documento' }}
                      span(v-if="$moment().isAfter(a.data_vencimento, 'day')") &nbsp;
                        strong.red--text (vencido {{ $moment(a.data_vencimento).format('DD/MM/YY') }})
                      span(v-else) &nbsp;
                        strong (vence {{ $moment(a.data_vencimento).format('DD/MM/YY') }})
                      span(v-if="i < anexosAlertaVencimento.length - 1") ,&nbsp;

                v-flex(v-if="resultadoAux && resultadoAux.resultado && resultadoAux.resultado.id && resultadoAux.opcao_questao_id").md12
                  v-layout(row, wrap, align-center).mb-1
                    v-flex
                      span.subheading.font-weight-bold Evidências
                      span.body-2.red--text.ml-2 Mínimo: {{ minEvidencias }} evidência(s)
                  v-layout(row, wrap).mt-1
                    v-flex(v-if="edicaoHabilitada || (resultadoAux.resultado.anexos && resultadoAux.resultado.anexos.length < minEvidencias)").md3.sm4.xs6.pa-2
                      v-card.anexo-card.anexo-add(@click="!loadingUpload && pickFile()", hover)
                        .anexo-thumb.d-flex.justify-center.align-center
                          v-progress-circular(v-if="loadingUpload", indeterminate, color="primary", size="36")
                          v-icon(v-else, size="48", color="grey lighten-1") cloud_upload
                        v-card-text.pa-2.text-xs-center
                          span.caption.grey--text.font-weight-bold {{ loadingUpload ? 'Enviando...' : 'Enviar evidência' }}

                    v-flex(v-for='evidencia in resultadoAux.resultado.anexos', :key='evidencia.id').md3.sm4.xs6.pa-2
                      v-card.anexo-card(hover)
                        .anexo-thumb(@click="visualizarEvidencia(evidencia)")
                          img(v-if="isImageUrl(evidencia.arquivo)", :src='getArquivoUrl(evidencia.arquivo)')
                          .doc-thumb(v-else)
                            v-icon(size="48", :color="getFileColor(evidencia)") {{ getFileIcon(evidencia) }}
                            span.caption.mt-1.font-weight-bold.text-uppercase {{ getFileExt(evidencia) }}
                        v-tooltip(top)
                          v-btn(icon, small, slot="activator", @click.stop="deleteEvidencia(evidencia)").anexo-delete.ma-0
                            v-icon(size="16", color="white") delete_forever
                          span Remover evidência
                        v-tooltip(v-if="evidencia.data_vencimento", top)
                          v-btn(icon, small, slot="activator", @click.stop="abrirEmailsVencimento(evidencia)").anexo-email.ma-0
                            v-icon(size="16", color="white") email
                          span Emails de alerta de vencimento
                        v-card-text.pa-2(@click="visualizarEvidencia(evidencia)")
                          .anexo-nome.caption.grey--text.text--darken-2 {{ evidencia.nome_original || 'Evidência' }}
                          .caption.grey--text.mt-1 {{ evidencia.createdAt | moment('DD/MM/YY HH:mm') }}
                          .mt-1
                            v-chip(v-if="evidencia.data_vencimento", label, small, :color="$moment().isAfter(evidencia.data_vencimento) ? '#C9302C' : ($moment().add(15, 'days').isAfter(evidencia.data_vencimento) ? '#EC971F' : '#318837')").white--text.caption.px-1.mr-1 Venc. {{ $moment(evidencia.data_vencimento).format('DD/MM/YY') }}
                            v-chip(v-if="evidencia.data_vencimento && emailsVencimentoCount(evidencia) > 0", label, small, color="#1565C0", @click.stop="abrirEmailsVencimento(evidencia)").white--text.caption.px-1.mr-1
                              v-icon(size="12", left) email
                              | {{ emailsVencimentoCount(evidencia) }}
                            v-chip(v-if="evidencia.feedbacks_anexos && evidencia.feedbacks_anexos.length", label, small, color="#E6E6E6", @click.stop="visualizarEvidencia(evidencia)").caption.black--text.px-1 {{ evidencia.feedbacks_anexos.length }} feedback(s)

          v-card-actions.headline.grey.lighten-2
            v-layout(row, wrap).pa-1
              v-flex.xs12.text-xs-right
                v-btn(color="black", flat, @click.native="dialogResultado = false; resultadoAux = {};") Fechar
                v-btn(v-if="resultadoAux.resultado && $root.user.permissao == 0", color="primary",  @click.native="dialogStatusResultado = true; statusResultado = resultadoAux.resultado.status").elevation-0.white--text Alterar Status
                v-btn(type="submit", color="bt-primary", :loading='loading', :disabled="!edicaoHabilitada || !resultadoAux.opcao_questao_id").elevation-0.white--text Salvar

    v-dialog(ref="dialogEvidencia", v-model="dialogEvidencia", width="auto", scrollable, max-width="900px", persistent)
      v-card
        v-card-title.headline.grey.lighten-2
          v-layout(row, wrap)
            v-flex.md11
              span.subheading Evidência anexada em {{ evidenciaAux.createdAt | moment('DD/MM/YYYY  HH:mm') }}
            v-flex.md1.text-xs-right
              v-tooltip(top)
                v-btn(icon, slot="activator", @click.native="$validator.pause(); dialogEvidencia = false; evidenciaAux = {}").pa-0.mx-0.my-0.ma-0
                  v-icon close
                span Fechar
        v-card-text
          v-layout(v-if="user.permissao === 0",row, wrap).pa-0.mx-0.my-0.ma-0.grey.lighten-2
            v-flex.my-1

              v-tooltip(top)
                template(v-slot:activator='{ on }')
                  v-icon(v-on='on', color="black", @click="addTextBox").mx-1 title
                span Adicionar texto

              v-divider(vertical).white
              v-tooltip(top)
                template(v-slot:activator='{ on }')
                  v-icon(v-on='on', color='black', @click="addCircle").mx-1 panorama_fish_eye
                span Desenhar círculo

              v-divider(vertical).white
              v-tooltip(top)
                template(v-slot:activator='{ on }')
                  v-icon(v-on='on', color='black', @click="addProhitedIcon").mx-1 do_not_disturb
                span Errado

              v-divider(vertical).white
              v-tooltip(top)
                template(v-slot:activator='{ on }')
                  v-icon(v-on='on', color='black', @click="addCheckIcon").mx-1 task_alt
                span Correto

              v-divider(vertical).white
              v-tooltip(top)
                template(v-slot:activator='{ on }')
                  v-icon(v-on='on', color='black', @click="addSquare").mx-1 crop_square
                span Desenhar quadrado

              v-divider(vertical).white
              v-tooltip(top)
                template(v-slot:activator='{ on }')
                  v-icon(v-on='on', color='black', @click="handleDeleteSelected").mx-1 delete
                span Remover objeto selecionado

              v-divider(vertical).white
              v-tooltip(top)
                template(v-slot:activator='{ on }')
                  v-icon(v-on='on', color='black', @click="handleDeleteAll").mx-1 delete_forever
                span Limpar todos os objetos


              v-divider(vertical).white
              v-tooltip(top)
                template(v-slot:activator='{ on }')
                  v-icon(v-on='on', color='black', @click="handleSaveCanvas").mx-1 save
                span Salvar imagem

              v-divider(vertical).white
              v-menu()
                template(v-slot:activator='{ on: menu }')
                  v-tooltip(top)
                    template(v-slot:activator='{ on: tooltip }')
                      v-icon(v-on='{...tooltip, ...menu}', :color="selectedColor.color").mx-1 format_color_text
                    span Escolher cor
                v-list.grey.lighten-2
                  v-list-tile(v-for='(item, index) in itemsColors' :key='index' @click="setColor(item)").pa-0.mx-0.my-0.ma-0
                    v-icon(large, :color="item.color", style="") stop
                    v-list-tile-title {{ item.nome }}


          v-divider(v-if="user.permissao === 0").grey.lighten-1
          v-layout(row, wrap)
            v-flex.md12.text-xs-center
                vue-fabric(v-if="user.permissao === 0", ref="canvas" id="canvas" :width="width" :height="height" @selection:created="selected" @selection:updated="selected")
                img(v-if="user.permissao !== 0", :src="getArquivoUrl(evidenciaAux.arquivo)", style="max-width: 100%; height: auto; display: block; margin: 0 auto;")

          v-layout(row, wrap).mt-3
            v-flex.md12.text-xs-center
              v-autocomplete(label="Escolher feedback", :items="listFeedbacks", :disabled="!listFeedbacks.length", item-text="texto", item-value="id", color="primary", v-model="feedback.id", append-outer-icon="add_circle", @click:append-outer="addFeedback(feedback.id)")
          v-layout(row, wrap)
            v-flex.md12.text-xs-center
              v-data-table(:headers='headersFeedbacks', :search='search', :items='evidenciaAux.feedbacks_anexos', :rows-per-page-items="[25,50,75,{ text:'Todos','value':-1 }]").elevation-0
                template(slot='items', slot-scope='props')
                  td.text-xs-left {{ props.item.id }}
                  td.text-xs-left {{ props.item.feedback.texto }}
                  td.text-xs-left {{ props.item.feedback.categoria_feedback.texto }}
                  td.text-xs-right
                    v-tooltip(top)
                      v-btn(slot="activator", flat, icon, fab, dark, color="red", small, @click="deleteFeedback(props.item)")
                        v-icon delete
                      span Excluir
        v-card-actions.headline.grey.lighten-2
          v-layout(row, wrap)
            v-flex.xs12.text-xs-right
              v-btn(color="black", flat, @click.native="dialogEvidencia = false; evidenciaAux = {}") Fechar

    v-dialog(v-model="dialogDicaImagem", width="auto", scrollable, max-width="700px", persistent)
      v-card
        v-card-title
          v-layout(row, wrap)
            v-flex.md11
              span.subheading
            v-flex.md1.text-xs-right
              v-tooltip(top)
                v-btn(icon, slot="activator", @click.native="dialogDicaImagem = false; dicaImagemAux = {}").pa-0.mx-0.my-0.ma-0
                  v-icon close
                span Fechar
        v-card-text
          v-layout(row, wrap)
            v-flex.md12.text-xs-center
              img(v-bind:src='dicaImagemAux', width="70%", height="auto")
        v-card-actions
          v-layout(row, wrap)
            v-flex.xs12.text-xs-right
              v-btn(color="black", flat, @click.native="dialogDicaImagem = false; dicaImagemAux = {}") Fechar

    v-dialog(v-if="dialogPdfPreview", v-model="dialogPdfPreview", width="auto", scrollable, max-width="950px", persistent)
      v-card
        v-card-title.headline.grey.lighten-2
          v-layout(row, wrap, align-center)
            v-flex.xs8.sm9
              span.subheading.text-truncate {{ pdfPreviewAux && pdfPreviewAux.nome_original || 'Documento PDF' }}
            v-flex.xs4.sm3.text-xs-right
              v-btn(flat, small, color="bt-primary", :href="pdfPreviewUrl", target="_blank") Nova aba
              v-btn(icon, @click.native="dialogPdfPreview = false; pdfPreviewAux = null; pdfPreviewUrl = ''; evidenciaAux = {}").pa-0.ma-0
                v-icon close
        v-card-text.pa-0
          iframe(:src="pdfPreviewUrl", style="width: 100%; max-width: 100%; height: 640px; border: none; display: block;")
          v-layout(row, wrap).mt-3.px-3
            v-flex.md12.text-xs-center
              v-autocomplete(label="Escolher feedback", :items="listFeedbacks", :disabled="!listFeedbacks.length", item-text="texto", item-value="id", color="primary", v-model="feedback.id", append-outer-icon="add_circle", @click:append-outer="addFeedback(feedback.id)")
          v-layout(row, wrap).px-3.pb-3
            v-flex.md12.text-xs-center
              v-data-table(:headers='headersFeedbacks', :search='search', :items='evidenciaAux.feedbacks_anexos', :rows-per-page-items="[25,50,75,{ text:'Todos','value':-1 }]").elevation-0
                template(slot='items', slot-scope='props')
                  td.text-xs-left {{ props.item.id }}
                  td.text-xs-left {{ props.item.feedback.texto }}
                  td.text-xs-left {{ props.item.feedback.categoria_feedback.texto }}
                  td.text-xs-right
                    v-tooltip(top)
                      v-btn(slot="activator", flat, icon, fab, dark, color="red", small, @click="deleteFeedback(props.item)")
                        v-icon delete
                      span Excluir

    v-dialog(v-if="resultadoAux", v-model="dialogStatusResultado", width="auto", scrollable, max-width="500px", persistent)
      v-card
        form(@submit.prevent="salvarResultado")
          v-card-title.headline.grey.lighten-2
            v-layout(row, wrap)
              v-flex.md11
                span.headline Alterar Status
              v-flex.md1.text-xs-right.mt-0
                v-tooltip(top)
                  v-btn(icon, slot="activator", @click.native="$validator.pause(); dialogStatusResultado = false;").pa-0.mx-0.my-0.ma-0
                    v-icon close
                  span Fechar
          v-card-text
            v-flex.md12.mb-0.my-0.mt-3
              v-radio-group(collumn, v-model="statusResultado").pa-0.my-0.mx-0.mt-0.mb-0
                v-radio(color="primary", v-for='status in allStatus', :key='status.id', :value='status.id')
                  template(v-slot:label='')
                    span.black--text.font-weight-regular {{ status.nome }}
              v-text-field(label="Revisão", v-model="textoRevisao")
          v-card-actions.headline.grey.lighten-2
            v-flex.xs12.text-xs-right
              v-btn(color="black", flat, @click.native="dialogStatusResultado = false;") Fechar
              v-btn(type="submit", color="bt-primary", :loading='loading').white--text Salvar

    v-dialog(v-model="dialogEmailsVencimento", width="auto", scrollable, max-width="520px", persistent)
      v-card
        v-card-title.headline.grey.lighten-2
          v-layout(row, wrap, align-center)
            v-flex.xs11
              span.subheading Emails para alerta de vencimento
            v-flex.xs1.text-xs-right
              v-btn(icon, @click.native="dialogEmailsVencimento = false; emailsVencimentoAux = null").pa-0.ma-0
                v-icon close
        v-card-text
          v-layout(row, wrap).pt-2
            v-flex.xs12
              .caption.grey--text.mb-3 Além do gestor e do auditado, estes emails também receberão o alerta quando o documento estiver próximo do vencimento.
            v-flex.xs12
              v-combobox(
                color="primary"
                label="Emails para alertas"
                hint="Digite o email e pressione Enter para adicionar"
                persistent-hint
                v-model="emailsVencimentoList"
                multiple
                chips
                deletable-chips
                append-icon=""
              )
        v-card-actions.headline.grey.lighten-2
          v-flex.xs12.text-xs-right
            v-btn(color="black", flat, @click.native="dialogEmailsVencimento = false; emailsVencimentoAux = null") Cancelar
            v-btn(color="bt-primary", :loading="loadingEmails", @click.native="salvarEmailsVencimento").white--text Salvar

    input(type='file', style='display: none', ref='fileChoose', accept='image/jpeg,image/png,image/gif,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', @change='onFilePicked')

    v-dialog(v-model="dialogDocumentDates", width="auto", scrollable, max-width="500px", persistent)
      v-card
        v-card-title.headline.grey.lighten-2
          span.headline Dados do Documento
        v-card-text
          v-layout(row, wrap)
            v-flex.md12
              span.body-2 Arquivo: {{ pendingDocumentFile ? pendingDocumentFile.name : '' }}
            v-flex.md6
              v-menu(v-model='menuDataEmissao', :close-on-content-click='false', lazy, transition='scale-transition', offset-y, full-width, max-width='290px', min-width='290px')
                template(v-slot:activator='{ on }')
                  v-text-field(v-on='on', v-model='documentDatesFormatted.data_emissao', label='Data de Emissão', readonly, prepend-icon='event')
                v-date-picker(v-model='documentDates.data_emissao', locale='pt-br', @input='menuDataEmissao = false')
            v-flex.md6
              v-menu(v-model='menuDataVencimento', :close-on-content-click='false', lazy, transition='scale-transition', offset-y, full-width, max-width='290px', min-width='290px')
                template(v-slot:activator='{ on }')
                  v-text-field(v-on='on', v-model='documentDatesFormatted.data_vencimento', label='Data de Vencimento', readonly, prepend-icon='event')
                v-date-picker(v-model='documentDates.data_vencimento', locale='pt-br', @input='menuDataVencimento = false')
        v-card-actions.headline.grey.lighten-2
          v-flex.xs12.text-xs-right
            v-btn(color='black', flat, @click.native='cancelDocumentUpload') Cancelar
            v-btn(color='bt-primary', @click.native='confirmDocumentUpload', :disabled='!documentDates.data_emissao || !documentDates.data_vencimento').white--text Confirmar

</template>

<script>
import _ from "lodash";
import IMG_CIRCLE from "@/assets/images/circle.png";
import IMG_ARROW from "@/assets/images/arrow-red.png";
import IMG_CLOSE from "@/assets/images/close-red.png";
import IMG_SQUARE from "@/assets/images/square-red.png";

export default {
    data() {
        return {
            width: 750,
            height: 500,
            feedback: {},
            auditoria: {},
            resultado: {},
            resultadoAux: {},
            evidenciaAux: {},
            dicaImagemAux: {},
            minEvidencias: 0,
            statusResultado: 0,
            textoRevisao: "",
            loadingUpload: false,
            edicaoHabilitada: false,
            dialogDocumentDates: false,
            menuDataEmissao: false,
            menuDataVencimento: false,
            pendingDocumentFile: null,
            documentDates: {
                data_emissao: null,
                data_vencimento: null,
            },
            itemsColors: [
                {
                    id: 1,
                    nome: "Branco",
                    color: "white",
                },
                {
                    id: 2,
                    nome: "Preto",
                    color: "black",
                },
                {
                    id: 3,
                    nome: "Vermelho",
                    color: "red",
                },
                {
                    id: 4,
                    nome: "Verde",
                    color: "green",
                },
                {
                    id: 5,
                    nome: "Azul",
                    color: "blue",
                },
            ],
            selectedColor: {
                id: 3,
                nome: "Vermelho",
                color: "red",
            },
            filter: {
                search: "",
                status: null,
                abertas: 1,
            },
            allStatus: [
                { id: 1, nome: "Aguardando Revisão" },
                { id: 2, nome: "Válido" },
                { id: 3, nome: "Inválido" },
            ],
            headers: [
                { text: "#", align: "left", value: "id" },
                { text: "Nome", align: "left", value: "questionario.nome" },
                {
                    text: "Auditado",
                    align: "left",
                    value: "auditado.identificador",
                },
                {
                    text: "Auditor Responsável",
                    align: "left",
                    value: "usuario.nome",
                },
                { text: "Data de Início", align: "left", value: "data_inicio" },
                { text: "Status", align: "left", value: "status" },
                { text: "Ações", align: "right", sortable: false },
            ],
            headersFeedbacks: [
                { text: "#", align: "left", value: "id" },
                { text: "Nome", align: "left", value: "feedback.texto" },
                {
                    text: "Categoria",
                    align: "left",
                    value: "categoria_feedback.texto",
                },
                { text: "Ações", align: "right", sortable: false },
            ],
            search: "",
            loading: false,
            dialogResultado: false,
            dialogEvidencia: false,
            dialogStatusResultado: false,
            dialogDicaImagem: false,
            dialogPdfPreview: false,
            pdfPreviewAux: null,
            pdfPreviewUrl: '',
            dialogEmailsVencimento: false,
            emailsVencimentoAux: null,
            loadingEmails: false,
            categoriasQuestoes: [],
            listFeedbacks: [],
            listIcons: [
                {
                    id: 2,
                    url: IMG_SQUARE,
                },
                {
                    id: 3,
                    url: IMG_CIRCLE,
                },
                {
                    id: 4,
                    url: IMG_ARROW,
                },
                {
                    id: 5,
                    url: IMG_CLOSE,
                },
            ],
            colorCanvas: "#FF0000",
        };
    },
    computed: {
        user() {
            return _.cloneDeep(this.$store.getters.user);
        },
        emailsVencimentoList: {
            get() {
                if (!this.emailsVencimentoAux) return [];
                try {
                    return JSON.parse(this.emailsVencimentoAux.emails_vencimento || '[]');
                } catch (_) {
                    return [];
                }
            },
            set(val) {
                if (this.emailsVencimentoAux) {
                    this.emailsVencimentoAux.emails_vencimento = JSON.stringify(val || []);
                }
            },
        },
        anexosAlertaVencimento() {
            const anexos = this.resultadoAux && this.resultadoAux.resultado && this.resultadoAux.resultado.anexos;
            if (!anexos || !anexos.length) return [];
            return anexos.filter(a => {
                if (!a.data_vencimento) return false;
                return this.$moment().add(15, 'days').isSameOrAfter(a.data_vencimento, 'day');
            });
        },
        documentDatesFormatted() {
            return {
                data_emissao: this.documentDates.data_emissao ? this.$moment(this.documentDates.data_emissao).format('DD/MM/YYYY') : '',
                data_vencimento: this.documentDates.data_vencimento ? this.$moment(this.documentDates.data_vencimento).format('DD/MM/YYYY') : '',
            };
        },
        list() {
            let categoriasQuestoes = _.cloneDeep(this.categoriasQuestoes);
            return categoriasQuestoes;
        },
        listCategorias() {
            const vm = this;
            let categorias = [];
            let categoriasQuestoes = [];

            let questoes = vm.filter.abertas
                ? vm.auditoria.questoes
                : vm.auditoria.questoesFechadas;

            _.map(questoes, (obj) => {
                categorias.push({
                    idCategoria: obj.categoria_questao_id,
                    nomeCategoria: obj.categoria_questao.texto,
                    idQuestao: obj.id,
                    nomeQuestao: obj.texto,
                    dicaQuestao: obj.observacao,
                    dicaImagemQuestao: obj.dica_imagem,
                    dataReferencia: obj.dataReferencia,
                    dataLimite: obj.dataLimite,
                    localizacao: obj.localizacao,
                    opcoesQuestao: obj.opcoes_questao,
                    resultados: obj.resultados,
                    resultado: obj.resultado,
                });
            });
            let groupCategoriasById = _.groupBy(categorias, "idCategoria");
            for (let prop in groupCategoriasById) {
                categoriasQuestoes.push({
                    idCategoria: groupCategoriasById[prop][0].idCategoria,
                    nomeCategoria: groupCategoriasById[prop][0].nomeCategoria,
                    questoes: vm.getQuestoes(groupCategoriasById[prop]),
                });
            }
            return categoriasQuestoes;
        },
    },
    mounted() {
        const vm = this;
        if (vm.$route.params.id) {
            vm.getAuditoria(vm.$route.params);
        }
    },
    methods: {
        getArquivoUrl(arquivo) {
            if (!arquivo) return '';
            return arquivo.startsWith('http') ? arquivo : 'https://' + arquivo;
        },
        emailsVencimentoCount(evidencia) {
            if (!evidencia || !evidencia.emails_vencimento) return 0;
            try {
                return JSON.parse(evidencia.emails_vencimento).length;
            } catch (_) {
                return 0;
            }
        },
        abrirEmailsVencimento(evidencia) {
            this.emailsVencimentoAux = { ...evidencia };
            this.dialogEmailsVencimento = true;
        },
        async salvarEmailsVencimento() {
            const vm = this;
            if (!vm.emailsVencimentoAux) return;
            try {
                vm.loadingEmails = true;
                await vm.$axios.put(`/resultado-anexo/${vm.emailsVencimentoAux.id}`, {
                    emails_vencimento: vm.emailsVencimentoAux.emails_vencimento || null,
                });
                const target = vm.resultadoAux.resultado.anexos.find(a => a.id === vm.emailsVencimentoAux.id);
                if (target) target.emails_vencimento = vm.emailsVencimentoAux.emails_vencimento || null;
                vm.dialogEmailsVencimento = false;
                vm.emailsVencimentoAux = null;
                window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Emails salvos com sucesso!' });
            } catch (error) {
                window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Erro ao salvar os emails. Tente novamente.' });
            } finally {
                vm.loadingEmails = false;
            }
        },
        clearCanvas() {
            let options = {
                imgUrl: this.evidenciaAux.arquivo,
                width: this.width,
                height: this.height,
                opacity: 1,
                scaleX: 1,
            };
            this.$refs.canvas.clear();
            this.$refs.canvas.setBackgroundImage(options);
        },
        selected(obj, option) {},
        async salvarResultado() {
            const vm = this;
            try {
                vm.loading = true;
                vm.resultadoAux.resultado.status = vm.statusResultado;
                vm.resultadoAux.resultado.revisao = vm.textoRevisao;
                const response = vm.$axios.put(
                    `/resultado/${vm.resultadoAux.resultado.id}`,
                    vm.resultadoAux.resultado,
                );
                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Status alterado com sucesso!",
                });
                vm.dialogStatusResultado = false;
                vm.loading = false;
            } catch (error) {
                vm.dialogStatusResultado = false;
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao alterar o status. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                vm.loading = false;
            }
        },

        async saveResultado(resultadoAux) {
            const vm = this;

            try {
                vm.loading = true;
                let resultado = {};
                resultado.auditoria_id = parseInt(
                    vm.$route.params.id ? vm.$route.params.id : null,
                );
                resultado.questao_id = vm.resultadoAux.idQuestao;
                resultado.opcao_questao_id = vm.resultadoAux.opcao_questao_id;
                resultado.data_referencia = this.$moment(
                    resultadoAux.dataReferencia,
                ).format("YYYY-MM-DD");
                const response = await vm.$axios.post("/resultado", resultado);
                if (response && response.data.id) {
                    vm.resultadoAux.resultado = response.data;
                    vm.resultadoAux.resultado.anexos = [];
                    vm.resultadoAux.resultado.status = response.data.status;
                    vm.loading = false;
                }
                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Questão respondida com sucesso. Verifique se a questão solicita envio de anexos!",
                });
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao responder a questão. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                vm.loading = false;
            }
            vm.loading = false;
        },

        async updateResultado(resultadoAux) {
            const vm = this;
            try {
                vm.loading = true;
                let resultado = {};
                resultado.id = vm.resultadoAux.resultado.id;
                resultado.questao_id = vm.resultadoAux.idQuestao;
                resultado.opcao_questao_id = vm.resultadoAux.opcao_questao_id;
                resultado.data_referencia = this.$moment(
                    resultadoAux.dataReferencia,
                ).format("YYYY-MM-DD");
                const response = await vm.$axios.put(
                    `/resultado/${resultado.id}`,
                    resultado,
                );
                if (response) {
                    vm.resultadoAux.resultado = response.data;
                }
                vm.loading = false;
                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Questão salva com sucesso! Verifique se a questão solicita envio de anexos!",
                });
                vm.dialogResultado = false;
                vm.getAuditoria(vm.$route.params);
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao salvar a questão. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                vm.loading = false;
            }
        },

        async salvar() {
            const vm = this;
            try {
                vm[
                    vm.resultadoAux.resultado && vm.resultadoAux.resultado.id
                        ? "updateResultado"
                        : "saveResultado"
                ](vm.resultadoAux);
            } catch (error) {
                window.getApp.$emit("APP_ALERT", { color: "red", text: error });
                vm.loading = false;
            }
        },
        getQuestoes(questoesAll) {
            let questoes = [];
            _.map(questoesAll, (q) => {
                questoes.push({
                    idQuestao: q.idQuestao,
                    nomeQuestao: q.nomeQuestao,
                    dicaQuestao: q.dicaQuestao,
                    dicaImagemQuestao: q.dicaImagemQuestao,
                    dataReferencia: q.dataReferencia,
                    dataLimite: q.dataLimite,
                    localizacao: q.localizacao,
                    opcoesQuestao: q.opcoesQuestao,
                    resultados: q.resultados,
                    resultado: q.resultado,
                });
            });
            return questoes;
        },
        async getAuditoria(params) {
            const vm = this;
            try {
                const response = await vm.$axios.get(
                    `/auditoria-resultado/${params.id}`,
                    {
                        params: {
                            fields: "auditado,usuario,questionario,opcoes_questao,revisao",
                        },
                    },
                );
                vm.auditoria = response.data || {};
                vm.loading = false;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Houve um erro ao buscar a auditoria, tente novamente",
                });
                vm.loading = false;
            }
        },
        async getFeedbacks() {
            const vm = this;
            try {
                vm.loading = true;
                const response = await vm.$axios.get(`/feedback`, {
                    params: { fields: "categoria_feedback" },
                });
                vm.listFeedbacks = response.data.rows || [];
                vm.loading = false;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Houve um erro ao buscar os feedbacks, tente novamente",
                });
                vm.loading = false;
            }
        },
        async openDialogResultado(questao) {
            const vm = this;
            let dataAtual = this.$moment().format("YYYY-MM-DD");
            vm.dialogResultado = true;
            vm.resultadoAux = questao;

            if (
                questao.resultado &&
                questao.opcoesQuestao &&
                questao.opcoesQuestao.length
            ) {
                vm.resultadoAux.opcao_questao_id = _.find(
                    questao.opcoesQuestao,
                    { id: questao.resultado.opcao_questao_id },
                ).id;
                vm.statusResultado =
                    questao &&
                    questao.resultado.status &&
                    !_.isNil(questao.resultado.status)
                        ? questao.resultado.status
                        : null;
                vm.statusResultado = 1;
                vm.minEvidencias = _.find(questao.opcoesQuestao, {
                    id: questao.resultado.opcao_questao_id,
                }).min_anexos;
            }

            if (questao.localizacao) {
                vm.edicaoHabilitada = false;
            } else if (this.user.permissao == 0) {
                vm.edicaoHabilitada = true;
            } else {
                if (
                    questao.resultado &&
                    questao.resultado.data_referencia &&
                    this.$moment(questao.dataReferencia).format("YYYY-MM-DD") !=
                        this.$moment(questao.resultado.data_referencia).format(
                            "YYYY-MM-DD",
                        )
                ) {
                    vm.edicaoHabilitada = false;
                } else if (
                    vm.auditoria.status == 1 &&
                    questao &&
                    questao.resultado &&
                    _.isNil(questao.resultado.status) &&
                    questao.resultado.status == 3
                ) {
                    vm.edicaoHabilitada = true;
                } else if (
                    this.$moment(dataAtual).isAfter(questao.dataLimite)
                ) {
                    vm.edicaoHabilitada = false;
                } else if (!questao.resultado) {
                    vm.edicaoHabilitada = true;
                } else if (questao.resultado && !questao.resultado.status) {
                    vm.edicaoHabilitada = true;
                } else if (questao.resultado && questao.resultado.status == 1) {
                    vm.edicaoHabilitada = false;
                } else if (questao.resultado && questao.resultado.status == 2) {
                    vm.edicaoHabilitada = false;
                } else if (questao.resultado && questao.resultado.status == 3) {
                    vm.edicaoHabilitada = true;
                } else if (questao.resultado && this.user.permissao != 0) {
                    vm.edicaoHabilitada = false;
                } else {
                    vm.edicaoHabilitada = true;
                }
            }
        },
        getMinEvidencias(opcao) {
            const vm = this;
            vm.minEvidencias = opcao.min_anexos;
        },
        pickFile() {
            const vm = this;
            vm.$refs.fileChoose.click();
        },
        isImageFile(file) {
            return file && file.type && file.type.startsWith('image/');
        },
        isImageUrl(url) {
            if (!url) return false;
            const ext = url.split('.').pop().toLowerCase().split('?')[0];
            return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
        },
        getFileIcon(evidencia) {
            const url = evidencia.arquivo || '';
            const mime = evidencia.mime_type || '';
            if (mime.includes('pdf') || url.split('?')[0].endsWith('.pdf')) return 'picture_as_pdf';
            if (mime.includes('word') || mime.includes('document') || url.endsWith('.doc') || url.endsWith('.docx')) return 'description';
            if (mime.includes('excel') || mime.includes('sheet') || url.endsWith('.xls') || url.endsWith('.xlsx')) return 'grid_on';
            if (mime.includes('csv') || url.endsWith('.csv')) return 'table_chart';
            return 'insert_drive_file';
        },
        getFileColor(evidencia) {
            const url = evidencia.arquivo || '';
            const mime = evidencia.mime_type || '';
            if (mime.includes('pdf') || url.split('?')[0].endsWith('.pdf')) return '#D50000';
            if (mime.includes('word') || mime.includes('document') || url.endsWith('.doc') || url.endsWith('.docx')) return '#1565C0';
            if (mime.includes('excel') || mime.includes('sheet') || url.endsWith('.xls') || url.endsWith('.xlsx')) return '#2E7D32';
            if (mime.includes('csv') || url.endsWith('.csv')) return '#00838F';
            return '#616161';
        },
        getFileExt(evidencia) {
            const nome = evidencia.nome_original || evidencia.arquivo || '';
            const ext = nome.split('?')[0].split('.').pop();
            return ext && ext.length <= 5 ? ext.toUpperCase() : 'DOC';
        },
        async saveResultadoAnexo(params, metadata = {}) {
            const vm = this;
            try {
                vm.loading = true;
                let resultadoAnexo = {};
                resultadoAnexo.resultado_valor_id =
                    vm.resultadoAux.resultado.id;
                resultadoAnexo.arquivo = params.location;
                resultadoAnexo.nome_original = metadata.nome_original || params.nome_original || null;
                resultadoAnexo.mime_type = metadata.mime_type || params.mime_type || null;
                resultadoAnexo.tipo_arquivo = metadata.tipo_arquivo || 'image';
                if (metadata.data_emissao) resultadoAnexo.data_emissao = metadata.data_emissao;
                if (metadata.data_vencimento) resultadoAnexo.data_vencimento = metadata.data_vencimento;
                const response = await vm.$axios.post(
                    "/resultado-anexo",
                    resultadoAnexo,
                );
                vm.resultadoAux.resultado.anexos.push(response.data);
                vm.loading = false;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Ocorreu um erro ao enviar a evidência. Tente novamente!",
                });
                vm.loading = false;
            }
        },
        async sendNewAttachment(attachment, metadata = {}) {
            const vm = this;

            vm.fileAnexo = attachment;
            let formData = new FormData();
            formData.append("file", vm.fileAnexo, attachment.name || "arquivo");
            vm.loadingUpload = true;
            try {
                const responseFile = await vm.$axios.post(
                    "resultado-anexo/arquivo",
                    formData,
                    {
                        headers: { "content-type": "multipart/form-data" },
                    },
                );
                vm.evidenciaAux.arquivo = responseFile.data.location;
                vm.loadingUpload = false;
                vm.saveResultadoAnexo(responseFile.data, metadata);
            } catch (ex) {
                vm.loadingUpload = false;
                window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Ocorreu um erro ao salvar a evidência. Tente novamente!",
                });
            }
        },
        cancelDocumentUpload() {
            const vm = this;
            vm.dialogDocumentDates = false;
            vm.pendingDocumentFile = null;
            vm.documentDates = { data_emissao: null, data_vencimento: null };
            vm.$refs.fileChoose.value = '';
        },
        confirmDocumentUpload() {
            const vm = this;
            const file = vm.pendingDocumentFile;
            if (!file) return;
            if (vm.documentDates.data_vencimento && vm.documentDates.data_emissao &&
                vm.documentDates.data_vencimento < vm.documentDates.data_emissao) {
                window.getApp.$emit('APP_ALERT', { color: 'red', text: 'A data de vencimento não pode ser anterior à data de emissão.' });
                return;
            }
            const metadata = {
                nome_original: file.name,
                mime_type: file.type,
                tipo_arquivo: file.type.startsWith('image/') ? 'image' : (file.type === 'application/pdf' ? 'pdf' : 'document'),
                data_emissao: vm.documentDates.data_emissao,
                data_vencimento: vm.documentDates.data_vencimento,
            };
            vm.dialogDocumentDates = false;
            vm.sendNewAttachment(file, metadata);
            vm.pendingDocumentFile = null;
            vm.documentDates = { data_emissao: null, data_vencimento: null };
            vm.$refs.fileChoose.value = '';
        },
        async onFilePicked(e) {
            const vm = this;
            const files = e.target.files;
            if (files[0] !== undefined) {
                let pickedFile = files[0];

                const MAX_SIZE = 25 * 1024 * 1024;
                if (pickedFile.size > MAX_SIZE) {
                    window.getApp.$emit('APP_ALERT', { color: 'red', text: 'O arquivo não pode ultrapassar 25MB.' });
                    vm.$refs.fileChoose.value = '';
                    return;
                }

                if (vm.isImageFile(pickedFile)) {
                    // Fluxo existente para imagens: comprimir e enviar
                    let reader = new FileReader();
                    reader.readAsDataURL(pickedFile);
                    reader.onload = (ev) => {
                        let image_url = ev.target.result;
                        let image = document.createElement("img");

                        image.src = image_url;
                        image.onload = (e) => {
                            let canvas = document.createElement("canvas");
                            const ctx = canvas.getContext("2d");

                            if (e.target.width > e.target.height) {
                                let ratio = vm.width / e.target.width;
                                canvas.width = vm.width;
                                canvas.height = e.target.height * ratio;
                            } else {
                                let ratio = vm.height / e.target.height;
                                canvas.width = e.target.width * ratio - 1;
                                canvas.height = vm.height;
                            }
                            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

                            let new_image_url = ctx.canvas.toDataURL(
                                "image/jpeg",
                                0.7,
                            );

                            fetch(new_image_url)
                                .then((r) => r.blob())
                                .then((blobFile) => {
                                    let file = new File([blobFile], pickedFile.name || "imagem.jpg", {
                                        type: "image/jpeg",
                                    });
                                    vm.sendNewAttachment(file, { nome_original: pickedFile.name, mime_type: 'image/jpeg', tipo_arquivo: 'image' });
                                });
                        };
                    };
                } else {
                    // Documentos: abrir dialog de datas antes de enviar
                    vm.pendingDocumentFile = pickedFile;
                    vm.documentDates = { data_emissao: null, data_vencimento: null };
                    vm.dialogDocumentDates = true;
                }
            }
        },
        async deleteEvidencia(evidencia) {
            const vm = this;
            try {
                const res = await vm.$confirm(
                    "Deseja realmente excluir?<br> Essa ação não poderá ser desfeita!",
                );
                if (!res) return;
                vm.loading = true;
                const response = await vm.$axios.delete(
                    `/resultado-anexo/${evidencia.id}/arquivo`,
                );
                const index = _.findIndex(vm.resultadoAux.resultado.anexos, {
                    id: evidencia.id,
                });
                let anexos = _.cloneDeep(vm.resultadoAux.resultado.anexos);
                vm.resultadoAux.resultado.anexos = anexos;
                _.remove(anexos, { id: evidencia.id });
                vm.loading = false;
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao remover a evidência. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                vm.loading = false;
            }
        },
        async deleteFeedback(feedback) {
            const vm = this;
            try {
                const response = await vm.$axios.delete(
                    `/feedback-anexo/${feedback.id}`,
                );
                if (response) {
                    const index = _.findIndex(
                        vm.evidenciaAux.feedbacks_anexos,
                        { id: feedback.id },
                    );
                    let feedbacks_anexos = _.cloneDeep(
                        vm.evidenciaAux.feedbacks_anexos,
                    );
                    _.remove(feedbacks_anexos, { id: feedback.id });
                    vm.evidenciaAux.feedbacks_anexos = feedbacks_anexos;
                }
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao remover o feedback. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            }
        },
        isPdf(evidencia) {
            if (!evidencia) return false;
            const mime = evidencia.mime_type || '';
            const url = evidencia.arquivo || '';
            return mime.includes('pdf') || url.toLowerCase().split('?')[0].endsWith('.pdf');
        },
        async visualizarEvidencia(evidencia) {
            const vm = this;
            const isImage = vm.isImageUrl(evidencia.arquivo);
            const isPdf = vm.isPdf(evidencia);

            if (isPdf) {
                const raw = evidencia.arquivo || '';
                const url = raw.startsWith('http') ? raw : 'https://' + raw;
                vm.evidenciaAux = evidencia;
                vm.getFeedbacks();
                vm.pdfPreviewAux = evidencia;
                vm.pdfPreviewUrl = url;
                vm.dialogPdfPreview = true;
                return;
            }

            if (!isImage) {
                // Outros documentos (Word, Excel, CSV): abrir em nova aba
                window.open(vm.getArquivoUrl(evidencia.arquivo), '_blank');
                return;
            }

            vm.dialogEvidencia = true;
            vm.evidenciaAux = evidencia;
            vm.getFeedbacks();

            if (isImage && vm.user.permissao === 0) {
                vm.$nextTick(() => {
                    let options = {
                        imgUrl: vm.getArquivoUrl(evidencia.arquivo),
                        width: vm.width,
                        height: vm.height,
                        opacity: 1,
                        scaleX: 1,
                    };
                    vm.$refs.canvas.setBackgroundImage(options);
                });
            }
        },
        async addFeedback(feedback_id) {
            const vm = this;
            try {
                if (!feedback_id) {
                    return window.getApp.$emit("APP_ALERT", {
                        color: "red",
                        text: "É necessário selecionar um feedback!",
                    });
                } else {
                    let data = {};
                    data.resultado_valor_anexo_id = vm.evidenciaAux.id;
                    data.feedback_id = feedback_id;
                    const response = await vm.$axios.post(
                        "/feedback-anexo",
                        data,
                    );
                    if (response && response.data && response.data.id) {
                        response.data.feedback = _.find(vm.listFeedbacks, {
                            id: response.data.feedback_id,
                        });
                        if (vm.evidenciaAux.feedbacks_anexos) {
                            vm.evidenciaAux.feedbacks_anexos.push(
                                response.data,
                            );
                        } else {
                            vm.evidenciaAux.feedbacks_anexos = [];
                            vm.evidenciaAux.feedbacks_anexos.push(
                                response.data,
                            );
                        }
                    }
                }
                vm.feedback = {};
            } catch (error) {
                vm.feedback = {};
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao adicionar a categoria. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            }
        },
        async urlToJpegBlob(imageUrl) {
            try {
                // Fetch the image data from the URL
                const response = await fetch(imageUrl);

                if (!response.ok) {
                    throw new Error(
                        `Failed to fetch image: ${response.status} ${response.statusText}`,
                    );
                }

                // Convert the image data to ArrayBuffer
                const arrayBuffer = await response.arrayBuffer();

                // Create a Blob with MIME type "image/jpeg"
                const jpegBlob = new Blob([arrayBuffer], {
                    type: "image/jpeg",
                });

                return jpegBlob;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Houve um erro ao salvar a imagem, tente novamente",
                });
                vm.loading = false;
                return null;
            }
        },

        // VUE FABRIC METHODS
        handleAdd(url) {
            const vm = this;
            vm.$refs.canvas.createImage(url);
        },
        handleDelete() {
            const vm = this;
            vm.$refs.canvas.removeCurrentObj();
        },
        addTextBox() {
            const vm = this;
            vm.$refs.canvas.createItext("Escreva aqui", {
                left: 30,
                top: 30,
                type: "text",
                fill: vm.colorCanvas,
            });
        },
        addCircle() {
            const vm = this;
            vm.$refs.canvas.createCircle({
                color: vm.colorCanvas,
                stroke: vm.colorCanvas,
                type: "circle",
                strokeWidth: 4,
            });
        },
        addCheckIcon() {
            const vm = this;
            const checkSVGData =
                "M39.04,7.604l-2.398-1.93c-1.182-0.95-1.869-0.939-2.881,0.311L16.332,27.494l-8.111-6.739 c-1.119-0.94-1.819-0.89-2.739,0.26l-1.851,2.41c-0.939,1.182-0.819,1.853,0.291,2.78l11.56,9.562c1.19,1,1.86,0.897,2.78-0.222 l21.079-25.061C40.331,9.294,40.271,8.583,39.04,7.604z";
            const options = {
                width: 50,
                height: 50,
                fillColor: vm.colorCanvas,
                left: 0,
                top: 0,
                strokeColor: vm.colorCanvas,
                fillColor: vm.colorCanvas,
                strokeWidth: 2,
                type: "svg",
            };
            vm.$refs.canvas.drawByPath(checkSVGData, options);
        },
        addProhitedIcon() {
            const vm = this;
            const prohibitedSVGData =
                "M18 0C8.059 0 0 8.059 0 18s8.059 18 18 18s18-8.059 18-18S27.941 0 18 0zm13 18c0 2.565-.753 4.95-2.035 6.965L11.036 7.036A12.916 12.916 0 0 1 18 5c7.18 0 13 5.821 13 13zM5 18c0-2.565.753-4.95 2.036-6.964l17.929 17.929A12.93 12.93 0 0 1 18 31c-7.179 0-13-5.82-13-13z";
            const options = {
                width: 100,
                height: 100,
                fillColor: vm.colorCanvas,
                left: 50,
                top: 50,
                strokeColor: vm.colorCanvas,
                fillColor: vm.colorCanvas,
                strokeWidth: 2,
                type: "svg",
            };
            vm.$refs.canvas.drawByPath(prohibitedSVGData, options);
        },
        addSquare() {
            const vm = this;
            vm.$refs.canvas.createRect({
                width: 60,
                height: 60,
                stroke: vm.colorCanvas,
                type: "rect",

                strokeWidth: 4,
            });
        },
        handleDeleteSelected() {
            const vm = this;
            vm.$refs.canvas.removeCurrentObj();
        },
        handleDeleteAll() {
            const vm = this;
            vm.$refs.canvas.clear();
            let options = {
                imgUrl: vm.evidenciaAux.arquivo,
                width: vm.width,
                height: vm.height,
                opacity: 1,
                scaleX: 1,
            };
            vm.$refs.canvas.setBackgroundImage(options);
        },
        setColor(item) {
            const vm = this;
            vm.selectedColor = item;
            vm.colorCanvas = item.color;
        },
        buildSvgImageUrl(svg) {
            const vm = this;
            return vm.$root.b64toBlob(window.btoa(svg));
            // let b64 = window.btoa(svg);
            // return "data:image/svg+xml;base64," + b64;
        },
        async updateImage(new_image) {
            const vm = this;
            const blobNewImage = vm.$root.b64toBlob(new_image);

            let formData = new FormData();
            formData.append("file", blobNewImage, "imagem.jpg");

            const res = await vm.$axios.post(
                "resultado-anexo/arquivo",
                formData,
                {
                    headers: { "content-type": "multipart/form-data" },
                },
            );

            const response = await vm.$axios.put(
                `/resultado-anexo/${vm.evidenciaAux.id}/arquivo`,
                { ...vm.evidenciaAux, arquivo: res.data.location },
            );

            vm.evidenciaAux.arquivo = response.data.arquivo;
            vm.clearCanvas();
            vm.loading = false;

            return window.getApp.$emit("APP_ALERT", {
                color: "green",
                text: "Edição salva com sucesso!",
            });
        },
        async insertBlobImageAndObjectsIntoCanvas(blob, jsonObjects) {
            const vm = this;
            try {
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                const img = new Image();
                img.src = URL.createObjectURL(blob);

                await new Promise((resolve) => {
                    img.onload = resolve;
                });

                if (img.width > img.height) {
                    let ratio = vm.width / img.width;
                    canvas.width = vm.width;
                    canvas.height = img.height * ratio;
                } else {
                    let ratio = vm.height / img.height;
                    canvas.width = img.width * ratio - 1;
                    canvas.height = vm.height;
                }

                context.drawImage(img, 0, 0, canvas.width, canvas.height);
                jsonObjects.forEach((obj) => {
                    context.strokeStyle = obj.stroke || "red";
                    context.lineWidth =
                        obj.strokeWidth * (obj.scaleY + obj.scaleX / 3);

                    switch (obj.type) {
                        case "svg":
                            let svgPathData = "";

                            obj.path.forEach((segment) => {
                                const [command, ...parameters] = segment;
                                svgPathData +=
                                    command + " " + parameters.join(" ") + " ";
                            });

                            let p = new Path2D(svgPathData);

                            context.translate(obj.left, obj.top);
                            context.scale(
                                Math.abs(obj.scaleX),
                                Math.abs(obj.scaleY),
                            );
                            context.fillStyle = obj.fill;
                            context.fill(p);
                            context.setTransform(1, 0, 0, 1, 0, 0);

                            break;

                        case "rect":
                            context.strokeRect(
                                obj.left,
                                obj.top,
                                obj.width * obj.scaleX,
                                obj.height * obj.scaleY,
                            );
                            break;
                        case "circle":
                            let multiplicator = Math.max(
                                Math.abs(obj.scaleX),
                                Math.abs(obj.scaleY),
                            );
                            let newRadius = obj.radius * multiplicator;
                            context.beginPath();
                            context.arc(
                                obj.left + newRadius,
                                obj.top + newRadius,
                                newRadius,
                                0,
                                360,
                            );
                            context.stroke();
                            break;
                        case "text":
                            context.fillStyle = obj.fill;
                            context.font = `${obj.fontSize * obj.scaleY}px ${
                                obj.fontFamily
                            }`;
                            context.fillText(
                                obj.text,
                                obj.left,
                                obj.top + obj.height,
                            );
                            break;
                    }
                });

                let new_url = context.canvas.toDataURL("image/jpeg");

                return new_url;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Houve um erro ao salvar a imagem, tente novamente",
                });
                vm.loading = false;
                return null;
            }
        },
        async handleSaveCanvas() {
            try {
                this.loading = true;
                this.urlToJpegBlob(this.evidenciaAux.arquivo).then(
                    async (blob) => {
                        if (blob) {
                            let canvasJSON = this.$refs.canvas.toJSON();
                            let { objects } = JSON.parse(canvasJSON);
                            const res =
                                await this.insertBlobImageAndObjectsIntoCanvas(
                                    blob,
                                    objects || [],
                                );

                            if (!res) {
                                this.loading = false;
                                return window.getApp.$emit("APP_ALERT", {
                                    color: "red",
                                    text: "Erro ao salvar Edição!",
                                });
                            }

                            this.updateImage(res);
                        }
                    },
                );
            } catch (err) {
                this.loading = false;
                return window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Erro ao salvar Edição!",
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.anexo-card {
    position: relative;
    cursor: pointer;
    transition: box-shadow 0.2s;

    .anexo-thumb {
        height: 130px;
        background: #f5f5f5;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    .doc-thumb {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    .anexo-nome {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
    }

    .anexo-delete {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 26px !important;
        height: 26px !important;
        min-width: 26px !important;
        background: rgba(198, 40, 40, 0.85) !important;
        border-radius: 4px !important;
        margin: 0 !important;
        padding: 0 !important;
        opacity: 0;
        transition: opacity 0.15s;
    }

    .anexo-email {
        position: absolute;
        top: 6px;
        right: 36px;
        width: 26px !important;
        height: 26px !important;
        min-width: 26px !important;
        background: rgba(21, 101, 192, 0.85) !important;
        border-radius: 4px !important;
        margin: 0 !important;
        padding: 0 !important;
        opacity: 0;
        transition: opacity 0.15s;
    }

    &:hover .anexo-delete,
    &:hover .anexo-email {
        opacity: 1;
    }
}

.anexo-add {
    border: 2px dashed #bdbdbd !important;
    background: #fafafa !important;
    box-shadow: none !important;

    .anexo-thumb {
        background: transparent;
    }

    &:hover {
        border-color: #1976D2 !important;
        background: #f0f4ff !important;
    }
}
.list-icons {
    background-color: 1px solid #e4e4e4;
}
.image-list {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    overflow-y: auto;

    overflow: scroll;

    display: flex;
    -webkit-overflow-scrolling: touch;
    flex-wrap: nowrap;
    border-top: 1px solid #e4e4e4;

    &::-webkit-scrollbar {
        display: none;
    }

    .image-wrapper {
        padding: 4vw;
        border-right: 1px solid #ebeef5;
        min-width: 20vw;

        display: -webkit-flex;
        display: -ms-flexbox;
        display: -moz-box;
        display: -webkit-box;
        display: flex;

        box-pack: center;
        -webkit--moz-box-pack: center;
        -moz-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;

        box-align: center;
        -moz-box-align: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;

        -moz-flex-wrap: nowrap;
        -webkit-flex-wrap: nowrap;
        flex-wrap: nowrap;

        position: relative;
        img {
            width: 20vw;
            object-fit: cover;
        }
        .pt-iconfont {
            position: absolute;
            right: 0vw;
            top: 0vw;
            color: #999;
            font-size: 4.5vw;
            padding: 1vw;
        }
    }
}
</style>
